var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { staticClass: "full-width", attrs: { padding: 5 } },
    [
      _c(
        "Box",
        { staticClass: "summary-grid" },
        [
          _c(
            "Card",
            {
              staticClass: "filters",
              attrs: { display: "flex", flexAlign: "center" }
            },
            [
              _c(
                "Box",
                { attrs: { marginRight: 3 } },
                [
                  _c("FancySelect", {
                    staticStyle: { width: "180px" },
                    attrs: {
                      clearable: true,
                      options: _vm.departmentOptions,
                      placeholder: "Select Department",
                      value: _vm.departmentFilter
                    },
                    on: {
                      input: function($event) {
                        return _vm.onDepartmentFilterChange($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "Box",
                { attrs: { marginRight: 3 } },
                [
                  _c("FancySelect", {
                    staticStyle: { width: "180px" },
                    attrs: {
                      clearable: true,
                      options: _vm.bankOptions,
                      placeholder: "Select Bank",
                      value: _vm.bankFilter
                    },
                    on: {
                      input: function($event) {
                        return _vm.onBankFilterChange($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "Box",
                { staticClass: "clear", on: { click: _vm.clearFilters } },
                [_vm._v("Clear Filters")]
              )
            ],
            1
          ),
          _c(
            "Card",
            { staticClass: "nopadding" },
            [
              _c("Grid", {
                attrs: {
                  items: _vm.currentPayments,
                  columns: _vm.columns,
                  noRecordsMsg: "No entries",
                  loading: _vm.loading,
                  total: _vm.filteredPayments.length,
                  sortable: true,
                  sort: [_vm.sort],
                  skip: _vm.page.skip,
                  "page-size": _vm.page.take,
                  pageable: true
                },
                on: {
                  sortchange: _vm.onSortChange,
                  pagechange: _vm.onPageChange
                },
                scopedSlots: _vm._u([
                  {
                    key: "EditCell",
                    fn: function({ props: { dataItem } }) {
                      return [
                        _c(
                          "td",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "RouterLink",
                              {
                                attrs: {
                                  to: `/household/${dataItem.donorId}/pledge/${dataItem.pledgeId}`
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "edit-icon" },
                                  [_c("Icon", { attrs: { name: "pencil" } })],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "PDFCell",
                    fn: function({ props: { dataItem } }) {
                      return [
                        _c("td", { staticClass: "text-center" }, [
                          _c("div", { staticClass: "action-cell" }, [
                            _c(
                              "a",
                              {
                                staticClass: "download-icon",
                                attrs: {
                                  href: _vm.getPaymentReceiptLink(dataItem),
                                  target: "_blank"
                                }
                              },
                              [
                                _c("Icon", {
                                  staticClass: "icon",
                                  attrs: { name: "file-pdf" }
                                }),
                                _c("span", [_vm._v("Receipt")])
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }